export default {"src":"/_next/static/media/fico5.471694b1.svg","height":58,"width":52};